import { render, staticRenderFns } from "./CommentInputPopup.vue?vue&type=template&id=37721ec4&"
import script from "./CommentInputPopup.vue?vue&type=script&lang=js&"
export * from "./CommentInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommentInputPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports